import { TabDirection } from '@msdk/definitions'

export type TabDirectionCastType = 'horizontal' | 'vertical'

export const TAB_DIRECTION_DEFAULT: TabDirectionCastType = 'horizontal'

export function castTabDirection(orientation?: TabDirection): TabDirectionCastType {
  if (orientation === TabDirection.Vertical) {
    return 'vertical'
  }
  return 'horizontal'
}
